import { Typography } from '@material-ui/core';
import { CheckCircle, Error, Refresh } from '@material-ui/icons';
import React from 'react';

import { CalendarModalBannerIcon } from './CalendarModal.models';
import { useStyles } from './CalendarModal.styles';
import { CalendarModalDeleteIcon } from './CalendarModalDeleteIcon';

interface Props {
  icon: CalendarModalBannerIcon;
  text: string;
  isError: boolean;
}

const getBannerIcon = (iconStr: CalendarModalBannerIcon) => {
  switch (iconStr) {
    case CalendarModalBannerIcon.ErrorX:
      return Error;
    case CalendarModalBannerIcon.Trashcan:
      return CalendarModalDeleteIcon;
    case CalendarModalBannerIcon.SyncCircle:
      return Refresh;
    default:
      return CheckCircle;
  }
};

export const CalendarModalBanner: React.FC<Props> = (props) => {
  const { icon, text, isError } = props;
  const Icon = getBannerIcon(icon);
  const classes = useStyles();

  return (
    <div
      className={`${classes.notificationWrapper} ${
        isError ? classes.errorTextWrapper : classes.successTextWrapper
      }`}
    >
      {Icon && <Icon className={classes[icon]} />}
      <Typography
        className={`${classes.notificationText} ${
          isError ? classes.errorText : classes.successText
        }`}
      >
        {text}
      </Typography>
    </div>
  );
};
